export default __webpack_public_path__ + "locales/ru/UploadPanel.json?hash=955f58735dfbadcdd6b7db28ba1e62d0";